/**
 * Created by Z179603 on 7/17/2016.
 */
'use strict';
angular.module('cvsApp')
    .service('commonServiceHelper', ['requestService', 'paymentAppData', function (requestService,paymentAppData ) {

        var service = {};

        // Added for GlobalNavigation
        function getService(serviceName, params, data, hideLoading) {
            var serviceNamesList = paymentAppData.serviceNames;
            if (serviceNamesList[serviceName]) {
                return requestService.makeRequest(serviceNamesList[serviceName], params, data, hideLoading);
            }
        }

        service.getWCMService = function (data) {
            var params;
            return getService(paymentAppData.serviceNames.getSpecialtyWCMContent, params, data);
        };

        service.getSpecialtyConfigService =function(data){
            var params;
            return getService(paymentAppData.serviceNames.getSpecialtyConfig, params, data);
        };

        return service;

    }]);